/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M24 3.5C24 5.433 22.433 7 20.5 7a3.4847 3.4847 0 0 1-2.1623-.7477l-3.2213 2.6529A3.4858 3.4858 0 0 1 15.5 10.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5c0-.2672.03-.5274.0867-.7774L6.274 8.6343C5.6341 9.465 4.6296 10 3.5 10 1.567 10 0 8.433 0 6.5S1.567 3 3.5 3 7 4.567 7 6.5c0 .2672-.03.5274-.0866.7774l2.3125 1.0882C9.8659 7.5351 10.8704 7 12 7c.8162 0 1.5671.2793 2.1623.7477l3.2213-2.6529A3.4857 3.4857 0 0 1 17 3.5C17 1.567 18.567 0 20.5 0S24 1.567 24 3.5Zm-1.5 0c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2Zm-19 5c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Zm8.5 4c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2ZM3.5 13C2.1193 13 1 14.1193 1 15.5v6C1 22.8807 2.1193 24 3.5 24S6 22.8807 6 21.5v-6C6 14.1193 4.8807 13 3.5 13Zm1 8.5v-6c0-.5523-.4477-1-1-1s-1 .4477-1 1v6c0 .5523.4477 1 1 1s1-.4477 1-1ZM9.5 19.5c0-1.3807 1.1193-2.5 2.5-2.5s2.5 1.1193 2.5 2.5v2c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5v-2Zm3.5 0v2c0 .5523-.4477 1-1 1s-1-.4477-1-1v-2c0-.5523.4477-1 1-1s1 .4477 1 1ZM20.5 10c-1.3807 0-2.5 1.1193-2.5 2.5v9c0 1.3807 1.1193 2.5 2.5 2.5s2.5-1.1193 2.5-2.5v-9c0-1.3807-1.1193-2.5-2.5-2.5Zm1 2.5c0-.5523-.4477-1-1-1s-1 .4477-1 1v9c0 .5523.4477 1 1 1s1-.4477 1-1v-9Z"
    clipRule="evenodd"
  />,
  'MenuMetrics'
);
